export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=6ec993ba&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/render/index.vue?vue&type=template&id=6ec993ba&scoped=true&
// module id = 11
// module chunks = 1